import { create } from "zustand";

type ExternalLinkDialogState = {
  /** The destination awaiting confirmation, or null while the dialog is closed. */
  url: string | null;
};

type ExternalLinkDialogActions = {
  openExternalLinkDialog: (url: string) => void;
  closeExternalLinkDialog: () => void;
};

export const useExternalLinkDialogStore = create<
  ExternalLinkDialogState & ExternalLinkDialogActions
>((set) => ({
  url: null,
  openExternalLinkDialog: (url) => set({ url }),
  closeExternalLinkDialog: () => set({ url: null }),
}));

/**
 * Asks the user to confirm before the app sends them to an external site. One
 * dialog serves the whole app — a table of hundreds of links needs no more than
 * one — so any surface can call this without rendering a dialog of its own.
 */
export const openExternalLinkDialog = (url: string) =>
  useExternalLinkDialogStore.getState().openExternalLinkDialog(url);
